import { render } from "./Help.vue?vue&type=template&id=4878c565"
import script from "./Help.vue?vue&type=script&lang=js"
export * from "./Help.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Help.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4878c565"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4878c565', __exports__)) {
    api.reload('4878c565', __exports__)
  }
  
  module.hot.accept("./Help.vue?vue&type=template&id=4878c565", () => {
    api.rerender('4878c565', render)
  })

}


export default __exports__